<template>
  <div>
    <delegation-single
      v-if="$route.name === 'delegation-single'"></delegation-single>
    <div v-else>
      <v-btn border class="mb-3" color="white" @click="$router.back()">
        <v-icon icon="mdi-chevron-left"></v-icon>
        <span class="font-weight-medium">Назад</span>
      </v-btn>
      <router-view></router-view>
    </div>
  </div>
</template>

<script lang="ts">
import DelegationSingle from '@/pages/delegation/DelegationSingle.vue'
import { initDelegation } from './index'

export default {
  name: 'DelegationIndex',
  components: { DelegationSingle },
  setup() {
    initDelegation()
  },
}
</script>

<style lang="scss" scoped></style>
